import { atom } from 'jotai';
export const $AppIdConfig = atom({
    psm: '',
    wapId: 0,
    appId: 0,
});
$AppIdConfig.debugLabel = '$AppIdConfig';
